import { render, staticRenderFns } from "./FactorSubfactors.vue?vue&type=template&id=15cbfb12&scoped=true&"
import script from "./FactorSubfactors.vue?vue&type=script&lang=js&"
export * from "./FactorSubfactors.vue?vue&type=script&lang=js&"
import style0 from "./FactorSubfactors.vue?vue&type=style&index=0&id=15cbfb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cbfb12",
  null
  
)

export default component.exports